import { render, staticRenderFns } from "./AssessmentSubmission.vue?vue&type=template&id=3fcf0956&"
import script from "./AssessmentSubmission.vue?vue&type=script&lang=js&"
export * from "./AssessmentSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports